import { z } from "zod";

export const postVideoSchema = z.object({
	wikiPageId: z.uuid(),
});

export type PostVideoSchema = z.infer<typeof postVideoSchema>;
